import http from './http.service';
import { RegisterFieldValueQueryFilter } from '../models/enums';

class DynamicFormService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/dynamicForms";
    }

    getEntryDetails(formEntryId, filter) {
        if (filter === RegisterFieldValueQueryFilter.All) {
            return this.$http.get(`${this.baseUrl}/${formEntryId}/allFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.Active) {
            return this.$http.get(`${this.baseUrl}/${formEntryId}/activeFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.ShowInDescription) {
            return this.$http.get(`${this.baseUrl}/${formEntryId}/showInDesctiptionFieldsDetails`);
        } else {
            return this.$http.get(`${this.baseUrl}/${formEntryId}/showInDesctiptionFieldsDetails`);
        }
    };
    getParticipationRequestFormFieldsNames(eventId) {
            return this.$http.get(`${this.baseUrl}/participationRequestFormFieldsNames/${eventId}`);

    }
}

export default new DynamicFormService();
